import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  computed,
  ElementRef,
  inject,
  Input,
  OnDestroy,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { AccountStateService } from '../../../services/account-state.service';
import { KeyboardShortcutsService } from '../../../services/keyboard-shortcuts.service';
import { LayoutService } from '../../../services/layout.service';
import { LoadingService } from '../../../services/loading.service';
import { LocalStorageService } from '../../../services/local-storage.service';
import { MessageService } from '../../../services/message.service';
import { PosthogService } from '../../../services/posthog.service';
import { RoutingService } from '../../../services/routing.service';
import {
  SEARCH_DIALOG_PANEL_CLASS,
  SearchDialogComponent,
} from '../../global-search/search-dialog/search-dialog.component';
import { NotificationsPopupComponent } from '../../notifications-tab/notifications-popup/notifications-popup.component';

declare let window: any;

@Component({
  selector: 'top-bar',
  imports: [MatButtonModule, MatIcon, TranslatePipe, MatTooltip, NotificationsPopupComponent],
  templateUrl: './top-bar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './top-bar.component.scss',
})
export class TopBarComponent implements AfterViewInit, OnDestroy {
  @Input() isDisplaySearch = true;
  @Input() isDisplayLogout = true;

  private dialog = inject(MatDialog);
  private _routingService = inject(RoutingService);
  private _messageService = inject(MessageService);
  private _layoutService = inject(LayoutService);
  private _loadingService = inject(LoadingService);
  private _accountStateService = inject(AccountStateService);
  private _keyboard = inject(KeyboardShortcutsService);
  private _elementRef = inject(ElementRef<HTMLElement>);
  private layoutService = inject(LayoutService);
  private _posthogService = inject(PosthogService);

  public $isMobile = computed(() => this._routingService.$isMobile());
  public $hasNewMessages = computed(() => this._messageService.$isNewMessage());
  public $hasOpenedMenu = computed(() => this._layoutService.hasOpenedMenu());

  public $account = this._accountStateService.$account;

  public isMac = this._keyboard.isMac();

  ngAfterViewInit(): void {
    this.layoutService.topMapOffset.set(
      this.layoutService.topMapOffset() + this._elementRef.nativeElement.offsetHeight
    );
  }

  public openSearchDialog() {
    this.dialog.open(SearchDialogComponent, {
      width: this.$isMobile() ? '90vw' : '70vw',
      maxWidth: '90vw',
      maxHeight: '80vh',
      position: { top: '10vh' },
      panelClass: SEARCH_DIALOG_PANEL_CLASS,
    });
  }

  public toggleMenu() {
    this._layoutService.toggleMenu();
  }

  public logout() {
    this._posthogService.captureEvent('logout', { source: 'component', from: 'top-bar' });
    LocalStorageService.removeElement('accountConnect');
    this._loadingService.logout();
    window.google?.accounts.id.disableAutoSelect();
  }

  public ngOnDestroy(): void {
    this.layoutService.topMapOffset.set(
      this.layoutService.topMapOffset() - this._elementRef.nativeElement.offsetHeight
    );
  }
}
